module.exports = __webpack_public_path__ + "img/corner-left-down.26b054f1.svg";